var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDotDragGrip = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 15.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 10.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 5.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 15.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 10.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 12.5,
  cy: 5.5,
  r: 1.5
})))));
export default SvgDotDragGrip;